"use client";

import { useRouter } from "next/navigation";
import { useEffect, type ReactNode } from "react";
import { homePathFor, useAuth } from "@/lib/auth";
import { PageSpinner } from "./ui/Spinner";

/**
 * 접근 제어.
 * need="anonymous": 로그인 상태면 홈으로 보낸다(로그인·가입 화면).
 * need="user": 로그인만 요구(대시보드, 업체 등록). 업체는 가입 뒤 선택 사항이다.
 * need="company": 로그인 + 업체 연결 요구(판정 조건 온보딩). 업체가 없으면 업체 등록으로 보낸다.
 */
export function Guard({ need, children }: { need: "anonymous" | "user" | "company"; children: ReactNode }) {
  const { status, me } = useAuth();
  const router = useRouter();

  const redirect =
    status === "loading"
      ? null
      : need === "anonymous"
        ? status === "authenticated"
          ? homePathFor(me)
          : null
        : status === "anonymous"
          ? "/login"
          : need === "company" && !me?.company
            ? "/onboarding/company"
            : null;

  useEffect(() => {
    if (redirect) router.replace(redirect);
  }, [redirect, router]);

  if (status === "loading" || redirect) return <PageSpinner />;
  return <>{children}</>;
}
